import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'constants/query-keys';
import { getProductsBySku } from 'services/ProductsService';

import type { IProduct, ReactQueryOptions } from 'types';

export function useProductsBySku(skus: string[] = [], queryOptions: ReactQueryOptions<IProduct[]> = {}) {
  return useQuery({
    queryKey: getKey(skus),
    queryFn: () => getProductsBySku({ skus }),
    ...queryOptions
  });
}

function getKey(skus: string[]): string[] {
  return [
    QUERY_KEYS.PRODUCTS_BY_SKU,
    ...skus
  ];
}
